import { useCallback } from "react";
import { useLocalStore } from "./use-local-store";

const KEY = "mrpanda.recentlyViewed.v1";
const MAX = 24;

/** Κρατά τα UUID των προϊόντων που είδε πρόσφατα ο χρήστης (localStorage). */
export function useRecentlyViewed() {
  const [ids, setIds] = useLocalStore<string[]>(KEY, []);

  const record = useCallback(
    (id: string) =>
      setIds((prev) => [id, ...prev.filter((x) => x !== id)].slice(0, MAX)),
    [setIds],
  );

  return { ids, record };
}